import React, { useState } from 'react';
import { FieldGroup, Modal, ModalFooter, PillButton, Select, Stack } from 'library/ui';
import { useUserContext } from 'UserContext';

interface IAddressSelectModalProps {
    isOpen: boolean;
    onAddressSelect: (id: string) => void;
    onClose: () => void;
}

export default function AddressSelectModal({ isOpen, onAddressSelect, onClose }: IAddressSelectModalProps) {
    const [selectedAddress, setSelectedAddress] = useState('');

    const { user } = useUserContext();
    const userAddresses = user?.address;

    if (!isOpen) return null;

    function onSelectClick() {
        onAddressSelect(selectedAddress);
        setSelectedAddress('');
    }

    return (
        <Modal title="Select the location this is for" onClose={onClose} width={420}>
            <Stack gap="md">
                <FieldGroup label="Location">
                    <Select
                        value={selectedAddress}
                        placeholder="Select a location"
                        fullWidth
                        options={
                            userAddresses?.map((b) => ({
                                key: b.id.toString(),
                                value: b.business_location?.name || '',
                            })) || []
                        }
                        onChange={(value) => setSelectedAddress(value)}
                    />
                </FieldGroup>
                <ModalFooter>
                    <PillButton variant="secondary" onClick={onClose}>
                        Cancel
                    </PillButton>
                    <PillButton variant="primary" onClick={onSelectClick}>
                        Select
                    </PillButton>
                </ModalFooter>
            </Stack>
        </Modal>
    );
}
